export const styles = {
  button: {
    color: theme => theme.palette.baseColors.deepSeaNavy.c100,
    '&:disabled': {
      color: theme => theme.palette.baseColors.deepSeaNavy.c25,
    },
  },
  wrapper: {},
  buttonWrapper: { position: 'relative' },
  closeIcon: {
    position: 'absolute',
    fontSize: '.7rem',
    top: '10px',
    right: '10px',
    background: 'white',
    '& > path': {
      transform: 'scale(1.3)',
      transformOrigin: 'center',
    },
  },
  popoverPaper: {
    width: 'clamp(300px, 100%, 400px)',
    mt: 3,
  },
  portfolioBox: {
    padding: 1,
    paddingLeft: 0.5,
  },
  filterName: { fontWeight: 'bold', display: 'inline' },
};
